import type { Ranges } from 'api/System/types'
import config from 'config'
import { selectSkipRefetchSaleTypes } from 'data/selectors'
import { getRequestParams } from 'data/utils'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { RequestDate } from 'types/UI'
import { fetchAction } from 'utils'

import * as constants from './constants'

interface FetchAction {
  dateCurrent: RequestDate
  dateCompared?: RequestDate | null
  range: Ranges
}

const fetchSaleTypes = createLogic<State, FetchAction>({
  type: constants.FETCH_SALE_TYPES,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const anyAction = action as any
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchSaleTypes(state, action.payload)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_SALE_TYPES_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.saleTypes, {
          ...baseRequestParams,
          ...getRequestParams(action as any),
        })

        dispatch({
          type: constants.FETCH_SALE_TYPES_SUCCESS,
          payload: {
            ...anyAction.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        ...action,
        type: constants.FETCH_SALE_TYPES_ERROR,
      })
    }
    done()
  },
})

export default [fetchSaleTypes]
